import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyBxLMNsMph-fKk_g_6rM1GyRv7e3zatEaY",
    authDomain: "media-app-bc774.firebaseapp.com",
    databaseURL: "https://media-app-bc774.firebaseio.com",
    projectId: "media-app-bc774",
    storageBucket: "media-app-bc774.appspot.com",
    messagingSenderId: "247064469271",
    appId: "1:247064469271:web:ba165c97ad9f72ead02152",
    measurementId: "G-Z9MC3BN7HM"
};

firebase.initializeApp(config)

export default firebase;